<app-breadcrumb
  [title]="t('إشعارات', 'Notifications', 'התראות')"
  [items]="[t('لوحة التحكم', 'Dashboard', 'לוח בקרה')]"
  [active_item]="t('إشعارات', 'Notifications', 'התראות')"
></app-breadcrumb>

<div class="container-fluid admin-push-notifications">
  <div class="bn-page-header">
    <h4>{{ t('إدارة الإشعارات', 'Push notifications', 'ניהול התראות') }}</h4>
    <p>
      {{
        t(
          'أنشئ رسائل جماعية، احفظ مسودات، وأرسل إشعارات FCM للمستخدمين.',
          'Create broadcasts, save drafts, and send FCM push notifications to users.',
          'צור שידורים, שמור טיוטות ושלח התראות FCM למשתמשים.'
        )
      }}
    </p>
  </div>

  <div class="card bn-shell mb-3">
    <div class="bn-shell__toolbar">
      <div class="d-flex gap-2 flex-wrap">
        <button class="btn bn-btn-create" type="button" (click)="openCreateModal(createBroadcastModal)">
          <i class="fa fa-plus-circle me-1"></i>
          {{ t('إنشاء إشعار', 'New broadcast', 'שידור חדש') }}
        </button>
        <button class="btn bn-btn-refresh" type="button" (click)="loadList()">
          <i class="fa fa-refresh me-1"></i>
          {{ t('تحديث', 'Refresh', 'רענון') }}
        </button>
      </div>
      <div class="col-md-4 col-lg-3 ms-auto" style="min-width: 200px;">
        <label class="form-label bn-label mb-1">{{ t('تصفية الحالة', 'Status', 'סטטוס') }}</label>
        <select
          class="form-select form-select-sm bn-filter-select"
          [(ngModel)]="statusFilter"
          (ngModelChange)="onStatusFilterChange()"
          name="bnStatusFilter"
        >
          <option *ngFor="let o of statusFilterOptions" [ngValue]="o.value">{{ statusFilterLabel(o) }}</option>
        </select>
      </div>
    </div>

    <div
      *ngIf="fcmDiagnostics"
      class="bn-status-strip"
      [class.bn-status-strip--ok]="fcmDiagnosticsOk()"
      [class.bn-status-strip--warn]="!fcmDiagnosticsOk()"
      role="status"
    >
      <span class="bn-status-strip__dot"></span>
      <span class="bn-status-strip__item">
        <strong>{{ t('Firebase', 'Firebase', 'Firebase') }}:</strong>
        {{
          fcmDiagnostics.firebase_admin_ready
            ? t('جاهز', 'Ready', 'מוכן')
            : t('غير مهيأ', 'Not ready', 'לא מוכן')
        }}
        <ng-container *ngIf="fcmDiagnostics.firebase_project_id">
          ({{ fcmDiagnostics.firebase_project_id }})
        </ng-container>
      </span>
      <span class="bn-status-strip__sep">|</span>
      <span class="bn-status-strip__item">
        <strong>{{ t('توكنات مسجّلة', 'Registered tokens', 'אסימונים רשומים') }}:</strong>
        {{ fcmDiagnostics.users_with_device_token }}
      </span>
      <span class="bn-status-strip__sep" *ngIf="!fcmDiagnosticsOk()">|</span>
      <span class="bn-status-strip__item" *ngIf="!fcmDiagnosticsOk()">
        {{ fcmDiagnostics.hint }}
      </span>
    </div>

    <div class="bn-body">
      <div class="table-responsive bn-table-wrap">
        <table class="table table-hover bn-table text-center align-middle mb-0">
          <thead>
            <tr>
              <th class="bn-th-id">#</th>
              <th class="text-start">{{ t('العنوان', 'Title', 'כותרת') }}</th>
              <th>{{ t('الجمهور', 'Audience', 'קהל') }}</th>
              <th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
              <th>{{ t('مجدول', 'Scheduled', 'מתוזמן') }}</th>
              <th>{{ t('تاريخ الإرسال', 'Sent at', 'נשלח') }}</th>
              <th>{{ t('المستخدمون', 'Users', 'משתמשים') }}</th>
              <th>{{ t('توكنات', 'Tokens', 'אסימונים') }}</th>
              <th>{{ t('تم التسليم', 'Delivered', 'נמסר') }}</th>
              <th class="bn-th-actions">{{ t('إجراءات', 'Actions', 'פעולות') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows">
              <td class="bn-cell-muted">{{ rowId(row) }}</td>
              <td class="text-start bn-cell-title" [title]="row.title">{{ row.title }}</td>
              <td><span class="bn-audience">{{ audienceLabel(row.audience) }}</span></td>
              <td>
                <span class="bn-status" [ngClass]="statusModifier(row.status)">{{ statusLabel(row.status) }}</span>
              </td>
              <td class="bn-cell-muted">{{ scheduledAtLabel(row) }}</td>
              <td class="bn-cell-muted">{{ row.sent_at ? (row.sent_at | date : 'dd/MM/yyyy HH:mm') : '—' }}</td>
              <td><span class="bn-metric">{{ row.recipient_user_count ?? '—' }}</span></td>
              <td><span class="bn-metric">{{ row.fcm_token_count ?? '—' }}</span></td>
              <td>
                <span
                  class="bn-metric"
                  [class.bn-metric--ok]="(row.fcm_success_count ?? 0) > 0"
                >
                  {{ row.fcm_success_count ?? '—' }}
                </span>
              </td>
              <td>
                <div class="btn-group btn-group-sm bn-action-group" role="group">
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    *ngIf="canSend(row)"
                    [disabled]="isSendSubmitting"
                    (click)="sendFromTable(row, progressModal)"
                    [title]="t('إرسال الآن', 'Send now', 'שלח')"
                  >
                    <i class="fa fa-paper-plane"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-warning"
                    *ngIf="canResend(row)"
                    [disabled]="isSendSubmitting"
                    (click)="resendFromTable(row, progressModal)"
                    [title]="t('إعادة إرسال', 'Resend', 'שלח שוב')"
                  >
                    <i class="fa fa-repeat"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    (click)="openDeliveryReportModal(deliveryReportModal, row)"
                    [title]="t('تقرير التسليم', 'Delivery report', 'דוח מסירה')"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    (click)="confirmDelete(row)"
                    [title]="t('حذف', 'Delete', 'מחק')"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="rows.length === 0">
              <td colspan="10" class="bn-empty">
                {{ t('لا توجد إشعارات بعد', 'No broadcasts yet', 'אין שידורים') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 bn-pagination" *ngIf="total > 0">
        <span class="small">
          {{ t('الصفحة', 'Page', 'עמוד') }} {{ page }} / {{ totalPages }} — {{ total }}
          {{ t('سجل', 'records', 'רשומות') }}
        </span>
        <div class="btn-group">
          <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="page <= 1" (click)="setPage(page - 1)">
            {{ t('السابق', 'Previous', 'הקודם') }}
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            [disabled]="page >= totalPages"
            (click)="setPage(page + 1)"
          >
            {{ t('التالي', 'Next', 'הבא') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #createBroadcastModal let-modal>
  <div class="bn-push-modal-root">
    <div class="modal-header bn-push-modal-header align-items-start flex-wrap gap-2 border-0">
      <div class="flex-grow-1 min-w-0">
        <h5 class="modal-title mb-0">{{ t('إنشاء إشعار جماعي', 'Create broadcast', 'יצירת שידור') }}</h5>
        <p class="bn-push-modal-subtitle mb-0 mt-2">
          {{
            t(
              'فعّل «حفظ لإرسال لاحقًا» لإنشاء مسودة، أو أرسل فورًا بدون تفعيلها.',
              'Turn on “save for later” to create a draft, or send immediately with it off.',
              'הפעל «שמור לשליחה מאוחרת» לטיוטה, או שלח מיד כשזה כבוי.'
            )
          }}
        </p>
      </div>
      <button type="button" class="btn-close bn-push-modal-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body bn-push-modal-body">
      <form [formGroup]="createForm" class="row g-3">
        <div class="col-12 bn-push-field">
          <label class="form-label">{{ t('العنوان', 'Title', 'כותרת') }} *</label>
          <input type="text" class="form-control bn-push-input" formControlName="title" maxlength="200" />
          <div class="d-flex justify-content-between align-items-center mt-1 flex-wrap gap-1">
            <div class="invalid-feedback d-block mb-0" *ngIf="invalidCreate('title')">
              {{ t('العنوان مطلوب', 'Title is required', 'כותרת נדרשת') }}
            </div>
            <span class="small bn-push-hint ms-auto">{{ createForm.controls.title.value?.length || 0 }} / 200</span>
          </div>
        </div>
        <div class="col-12 bn-push-field">
          <label class="form-label">{{ t('النص', 'Message', 'טקסט') }} *</label>
          <textarea class="form-control bn-push-input" rows="4" formControlName="message" maxlength="4000"></textarea>
          <div class="d-flex justify-content-between align-items-center mt-1 flex-wrap gap-1">
            <div class="invalid-feedback d-block mb-0" *ngIf="invalidCreate('message')">
              {{ t('النص مطلوب', 'Message is required', 'טקסט נדרש') }}
            </div>
            <span class="small bn-push-hint ms-auto">{{ createForm.controls.message.value?.length || 0 }} / 4000</span>
          </div>
        </div>
        <div class="col-md-7 bn-push-field">
          <label class="form-label">{{ t('الجمهور', 'Audience', 'קהל') }} *</label>
          <select class="form-select bn-push-select" formControlName="audience">
            <option *ngFor="let o of audienceOptions" [ngValue]="o.value">
              {{ t(o.labelAr, o.labelEn, o.labelHe) }}
            </option>
          </select>
        </div>
        <div class="col-12" *ngIf="!createForm.get('saveDraft')?.value">
          <div class="bn-draft-card bn-push-draft-card rounded-3 p-3 border-primary border-opacity-25">
            <div class="form-check mb-0">
              <input
                class="form-check-input bn-push-check"
                type="checkbox"
                formControlName="persistHistory"
                id="bnPersistHistory"
              />
              <label class="form-check-label fw-semibold" for="bnPersistHistory">
                {{
                  t(
                    'احفظ في الجدول لإعادة الإرسال لاحقًا',
                    'Save to table for resend later',
                    'שמור בטבלה לשליחה חוזרת'
                  )
                }}
              </label>
            </div>
            <p class="bn-push-hint mb-0 mt-2 ms-4 ps-1">
              {{
                t(
                  'عند إلغاء التحديد، يُرسل الإشعار مرة واحدة ولن يُسجَّل في الجدول.',
                  'If unchecked, the notification is sent once and will not appear in this table.',
                  'כשמבטלים את הסימון, ההודעה נשלחת פעם אחת ולא תוצג בטבלה.'
                )
              }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="bn-draft-card bn-push-draft-card rounded-3 p-3">
            <div class="form-check mb-0">
              <input class="form-check-input bn-push-check" type="checkbox" formControlName="saveDraft" id="bnSaveDraft" />
              <label class="form-check-label fw-semibold" for="bnSaveDraft">
                {{ t('حفظ لإرسال لاحقًا (مسودة)', 'Save for later (draft)', 'שמור לשליחה מאוחרת') }}
              </label>
            </div>
            <p class="bn-push-hint mb-0 mt-2 ms-4 ps-1">
              {{
                t(
                  'لن يُرسل الإشعار الآن. يمكنك جدولة وقت أو الإرسال يدويًا من الجدول.',
                  'Nothing is sent now. Schedule a time or send manually from the table.',
                  'לא נשלח עכשיו. אפשר לתזמן או לשלוח ידנית מהטבלה.'
                )
              }}
            </p>
            <div class="row g-2 mt-3 ms-4 ps-1" *ngIf="createForm.get('saveDraft')?.value">
              <div class="col-md-10 col-lg-8">
                <label class="form-label small mb-1">{{ t('وقت الإرسال المقترح', 'Suggested send time', 'זמן משוער') }}</label>
                <input type="datetime-local" class="form-control form-control-sm bn-push-input" formControlName="scheduledAt" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer bn-push-modal-footer flex-wrap gap-2 border-0">
      <button type="button" class="btn btn-light border bn-push-btn-secondary px-4" (click)="modal.dismiss()">
        {{ t('إلغاء', 'Cancel', 'ביטול') }}
      </button>
      <button
        type="button"
        class="btn btn-primary bn-push-btn-primary px-4 shadow-sm"
        [disabled]="isCreateSubmitting"
        (click)="submitCreate(modal, progressModal)"
      >
        <span *ngIf="!createForm.get('saveDraft')?.value">
          <i class="fa fa-paper-plane me-1"></i>
          {{ t('إرسال الآن', 'Send now', 'שלח') }}
        </span>
        <span *ngIf="createForm.get('saveDraft')?.value">
          <i class="fa fa-save me-1"></i>
          {{ t('حفظ المسودة', 'Save draft', 'שמור') }}
        </span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #progressModal let-modal>
  <div class="bn-push-modal-root">
    <div class="modal-header bn-push-modal-header align-items-center border-0">
      <h5 class="modal-title mb-0">{{ t('تقدّم الإرسال', 'Sending…', 'שולח…') }}</h5>
      <button type="button" class="btn-close bn-push-modal-close" [attr.aria-label]="t('إغلاق', 'Close', 'סגור')" (click)="closeProgressModal()"></button>
    </div>
    <div class="modal-body bn-push-modal-body bn-progress-body" *ngIf="dispatchSnapshot">
      <div class="bn-progress-phase-wrap mb-3">
        <div class="bn-progress-phase">{{ dispatchSnapshot.phase }}</div>
        <span class="badge rounded-pill bn-progress-count" *ngIf="dispatchSnapshot.recipients?.length">
          {{ dispatchSnapshot.recipients.length }}
          {{ t('مستلم', 'recipients', 'נמענים') }}
        </span>
      </div>
      <div class="bn-recipient-scroll rounded-3 border bn-push-recipient-box">
        <div *ngIf="!dispatchSnapshot.recipients?.length" class="p-4 text-center bn-push-hint small">
          {{ t('في انتظار أول مستلم…', 'Waiting for first recipient…', 'ממתין…') }}
        </div>
        <ul class="list-group list-group-flush bn-recipient-list mb-0" *ngIf="dispatchSnapshot.recipients?.length">
          <li class="list-group-item bn-recipient-item d-flex justify-content-between align-items-center py-2 px-3" *ngFor="let r of dispatchSnapshot.recipients">
            <span class="bn-recipient-label text-truncate me-2">{{ r.label }}</span>
            <span class="small bn-push-hint flex-shrink-0">#{{ r.userId }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal-footer bn-push-modal-footer border-0">
      <button type="button" class="btn btn-light border bn-push-btn-secondary px-4" (click)="closeProgressModal()">
        {{ t('إغلاق', 'Close', 'סגור') }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #deliveryReportModal let-modal>
  <div class="bn-push-modal-root bn-delivery-report">
    <div class="modal-header bn-push-modal-header border-0">
      <div class="flex-grow-1 min-w-0">
        <h5 class="modal-title mb-0">{{ t('تقرير تفصيلي للإشعار', 'Notification delivery report', 'דוח מסירה מפורט') }}</h5>
        <p class="bn-push-modal-subtitle mb-0 mt-2 text-truncate" *ngIf="deliveryReportBroadcast?.title" [title]="deliveryReportBroadcast.title">
          {{ deliveryReportBroadcast.title }}
        </p>
        <p class="small bn-push-hint mb-0 mt-1" *ngIf="deliveryReportBroadcast?.message">{{ deliveryReportBroadcast.message }}</p>
      </div>
      <button type="button" class="btn-close bn-push-modal-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body bn-push-modal-body" *ngIf="deliveryReportBroadcast">
      <div class="bn-report-meta row g-2 mb-3">
        <div class="col-auto">
          <span class="bn-status" [ngClass]="statusModifier(deliveryReportBroadcast.status)">{{ statusLabel(deliveryReportBroadcast.status) }}</span>
        </div>
        <div class="col-auto bn-cell-muted small">
          {{ audienceLabel(deliveryReportBroadcast.audience) }}
        </div>
        <div class="col-auto bn-cell-muted small" *ngIf="deliveryReportBroadcast.sent_at">
          {{ deliveryReportBroadcast.sent_at | date : 'dd/MM/yyyy HH:mm' }}
        </div>
      </div>

      <div class="bn-report-summary row g-2 mb-3" *ngIf="deliveryReportSummary">
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card">
            <span class="bn-report-card__label">{{ t('المستخدمون', 'Users', 'משתמשים') }}</span>
            <strong>{{ deliveryReportSummary.targeted_users }}</strong>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card">
            <span class="bn-report-card__label">{{ t('التجار', 'Merchants', 'סוחרים') }}</span>
            <strong>{{ deliveryReportSummary.distinct_merchants }}</strong>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card">
            <span class="bn-report-card__label">{{ t('التوكنات', 'Tokens', 'אסימונים') }}</span>
            <strong>{{ deliveryReportSummary.registered_tokens }}</strong>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card bn-report-card--ok">
            <span class="bn-report-card__label">{{ t('تم التسليم', 'Delivered', 'נמסר') }}</span>
            <strong>{{ deliveryReportSummary.delivered_count }}</strong>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card bn-report-card--fail">
            <span class="bn-report-card__label">{{ t('فشل', 'Failed', 'נכשל') }}</span>
            <strong>{{ deliveryReportSummary.failed_count }}</strong>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-2">
          <div class="bn-report-card bn-report-card--muted">
            <span class="bn-report-card__label">{{ t('بدون توكن', 'No token', 'ללא אסימון') }}</span>
            <strong>{{ deliveryReportSummary.no_token_users }}</strong>
          </div>
        </div>
      </div>

      <div class="alert alert-light border bn-report-empty" *ngIf="!deliveryReportLoading && !deliveryReportHasDetailed">
        {{
          t(
            'لا يتوفر تقرير تفصيلي لهذا الإشعار (أُرسل قبل تفعيل التقرير أو لم يُرسل بعد).',
            'Detailed report is not available for this notification (sent before reporting was enabled, or not sent yet).',
            'דוח מפורט אינו זמין להתראה זו (נשלח לפני שהדוח הופעל, או שטרם נשלח).'
          )
        }}
      </div>

      <ng-container *ngIf="deliveryReportHasDetailed">
        <div class="row g-2 mb-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label bn-label mb-1">{{ t('حالة التسليم', 'Delivery status', 'סטטוס מסירה') }}</label>
            <select
              class="form-select form-select-sm bn-filter-select"
              [(ngModel)]="deliveryReportStatusFilter"
              (ngModelChange)="onDeliveryReportStatusChange()"
              name="deliveryReportStatusFilter"
            >
              <option *ngFor="let o of deliveryStatusFilterOptions" [ngValue]="o.value">{{ deliveryStatusFilterLabel(o) }}</option>
            </select>
          </div>
          <div class="col-md-8">
            <label class="form-label bn-label mb-1">{{ t('بحث', 'Search', 'חיפוש') }}</label>
            <input
              type="search"
              class="form-control form-control-sm"
              [(ngModel)]="deliveryReportSearch"
              (ngModelChange)="onDeliveryReportSearchInput()"
              name="deliveryReportSearch"
              [placeholder]="t('اسم تاجر، مستخدم، هاتف…', 'Merchant, user, phone…', 'סוחר, משתמש, טלפון…')"
            />
          </div>
        </div>

        <div class="text-center py-4" *ngIf="deliveryReportLoading">
          <div class="spinner-border text-primary spinner-border-sm" role="status"></div>
        </div>

        <div class="table-responsive bn-report-table-wrap" *ngIf="!deliveryReportLoading">
          <table class="table table-sm table-hover bn-report-table align-middle mb-0">
            <thead>
              <tr>
                <th class="text-start">{{ t('التاجر / الشركة', 'Merchant / company', 'סוחר / חברה') }}</th>
                <th class="text-start">{{ t('المستخدم', 'User', 'משתמש') }}</th>
                <th>{{ t('الجهاز', 'Device', 'מכשיר') }}</th>
                <th>{{ t('القناة', 'Channel', 'ערוץ') }}</th>
                <th>{{ t('توكن', 'Token', 'אסימון') }}</th>
                <th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
                <th>{{ t('الوقت', 'Time', 'זמן') }}</th>
                <th class="text-start">{{ t('خطأ', 'Error', 'שגיאה') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of deliveryReportRows">
                <td class="text-start">
                  <div class="fw-semibold">{{ merchantDisplayName(item) }}</div>
                  <div class="small bn-cell-muted">{{ merchantMeta(item) }}</div>
                </td>
                <td class="text-start">
                  <div>{{ userDisplayName(item) }}</div>
                  <div class="small bn-cell-muted" *ngIf="item.phone_number && item.user_name">#{{ item.user_id }} · {{ item.phone_number }}</div>
                </td>
                <td>{{ item.device_type || '—' }}</td>
                <td>{{ channelLabel(item.channel) }}</td>
                <td>
                  <span class="bn-yesno" [class.bn-yesno--yes]="item.has_token" [class.bn-yesno--no]="!item.has_token">
                    {{ item.has_token ? t('نعم', 'Yes', 'כן') : t('لا', 'No', 'לא') }}
                  </span>
                </td>
                <td>
                  <span class="bn-delivery" [ngClass]="deliveryStatusModifier(item.delivery_status)">
                    {{ deliveryStatusLabel(item.delivery_status) }}
                  </span>
                </td>
                <td class="bn-cell-muted small text-nowrap">{{ item.attempted_at | date : 'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-start small text-danger">
                  <ng-container *ngIf="item.error_code || item.error_message">
                    <span *ngIf="item.error_code">{{ item.error_code }}</span>
                    <span *ngIf="item.error_code && item.error_message"> — </span>
                    <span *ngIf="item.error_message">{{ item.error_message }}</span>
                  </ng-container>
                  <span *ngIf="!item.error_code && !item.error_message">—</span>
                </td>
              </tr>
              <tr *ngIf="deliveryReportRows.length === 0">
                <td colspan="8" class="text-center bn-cell-muted py-4">
                  {{ t('لا توجد نتائج', 'No results', 'אין תוצאות') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2" *ngIf="deliveryReportTotalPages > 1 && !deliveryReportLoading">
          <span class="small bn-cell-muted">
            {{ t('صفحة', 'Page', 'עמוד') }} {{ deliveryReportPage }} / {{ deliveryReportTotalPages }}
            ({{ deliveryReportTotal }} {{ t('سجل', 'records', 'רשומות') }})
          </span>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-secondary" [disabled]="deliveryReportPage <= 1" (click)="setDeliveryReportPage(deliveryReportPage - 1)">
              {{ t('السابق', 'Prev', 'הקודם') }}
            </button>
            <button type="button" class="btn btn-outline-secondary" [disabled]="deliveryReportPage >= deliveryReportTotalPages" (click)="setDeliveryReportPage(deliveryReportPage + 1)">
              {{ t('التالي', 'Next', 'הבא') }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer bn-push-modal-footer border-0">
      <button type="button" class="btn btn-primary bn-push-btn-primary px-4 shadow-sm" (click)="modal.close()">{{ t('إغلاق', 'Close', 'סגור') }}</button>
    </div>
  </div>
</ng-template>
